import { cn } from '@/utils'

const NavMenuButton = ({
  open = false,
  setOpen
}: {
  open: boolean
  setOpen: (open: boolean) => void
}) => {
  const toggleMenu = () => {
    setOpen(!open)
  }

  return (
    <button
      className="relative h-10 w-10 rounded-lg text-white hover:bg-zinc-900"
      onClick={toggleMenu}
    >
      <span className="sr-only">Open main menu</span>
      <div className="absolute left-1/2 top-1/2 block w-5 -translate-x-1/2 -translate-y-1/2 transform">
        <span
          aria-hidden="true"
          className={cn(
            `absolute block h-0.5 w-5 transform bg-current transition duration-500 ease-in-out`,
            { 'rotate-45': open, '-translate-y-1.5': !open }
          )}
        ></span>
        <span
          aria-hidden="true"
          className={cn(
            `absolute block h-0.5 w-5 transform bg-current transition duration-500 ease-in-out`,
            { 'opacity-0': open }
          )}
        ></span>
        <span
          aria-hidden="true"
          className={cn(
            `absolute block h-0.5 w-5 transform bg-current transition duration-500 ease-in-out`,
            { '-rotate-45': open, 'translate-y-1.5': !open }
          )}
        ></span>
      </div>
    </button>
  )
}

export default NavMenuButton
